// src/components/Header.js
import React from 'react';

const Header = () => {
  return (
    <header className="banner-header">
      <div className="banner-container">
        <div className="banner-content">
          <img 
            src="/img/monad.svg" 
            alt="MoonPools" 
            className="banner-logo"
          />
          <h1>MoonPools</h1>
          <p>"Stake, wait, celebrate"</p>
        </div>
      </div>
    </header>
  );
};

export default Header;